import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sizeMB'
})
export class SizeMBPipe implements PipeTransform {

  transform(value: number): string {
    let sizeInput = (value/1048576).toFixed(2);
    return sizeInput+" MB";
  }

}
